import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = { class: "emq-table-footer" }

import { ref, computed, watch, onUnmounted, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'


import { GetBrandPCList, UpsertBrandAuth } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat, throttleBtn } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { ElMessage, ElMessageBox } from 'element-plus'
import { FieldEnable } from '@/types/types'

import OperatorTerminalConfigPCUpsert from './OperatorTerminalConfigPCUpsert.vue'



import { defineComponent, nextTick } from 'vue'

const __default__ = defineComponent({
    name: 'OperatorTerminalConfigPC',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {
        type: Boolean,
        required: true,
    },
    opeartorId: {
        type: String,
        default: '',
    },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18n()




const showDialog = computed({
    get: () => {
        return props.modelValue
    },
    set: (val: boolean) => {
        emit('update:modelValue', val)
    },
})

const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { getPaymentModeDesc, getPaymentChannelDesc, getCurrencySymbol } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')



const showBindPCDialog = ref(false)
const bindPC = () => {
    showBindPCDialog.value = true
}

const handleSearch = async () => {
    params.value = genQueryParams(fuzzyParams.value)
    console.log('params', params.value)
    loadTableData({ page: 1 })
}



const handleSwitchDefault = async (row: any) => {
  try {
    console.log('---> handleSwitchDefault', row.isDefault)
    await UpsertBrandAuth({
        id: row.id,
        isDefault: row.isDefault ? FieldEnable.CES_ENABLE : FieldEnable.CES_DISABLE,
    })
    ElMessage.success(t('Base.opSuccess'))
    loadTableData()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const handleSwitchPsDefault = async (row: any) => {
  try {
    console.log('---> handleSwitchPsDefault', row.psDefault)
    await UpsertBrandAuth({
        id: row.id,
        defaultPs: row.psDefault ? FieldEnable.CES_ENABLE : FieldEnable.CES_DISABLE,
    })
    ElMessage.success(t('Base.opSuccess'))
    loadTableData()
    return Promise.resolve()
  } catch (error) {
    console.error(error)
    return Promise.reject()
  }
}

const genQueryParams = (params: Record<string, any>) => {
    let newParams: Record<string, any> = {}
    const { id } = params
    newParams = {
        id: id || undefined,
    }
    return newParams
}

const loadTableData = async (_params = {}) => {
    lockTable.value = true
    const sendParams = {
        ...params.value,
        pageReq: {
            ...pageParams.value,
            ..._params,
        },
        operatorId: props.opeartorId,
    }

    try {
        const { list = [], pageReply = {} } = await GetBrandPCList(sendParams)
        const meta = toPageMeta(sendParams.pageReq, pageReply)
        tableData.value = list
        setPageMeta(meta)
        updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
    } catch (error) {
        tableData.value = []
        initPageMeta()
    } finally {
        lockTable.value = false
    }
}


watch(showDialog, async (val) => {
    if (val && props.opeartorId !== '' && props.opeartorId !== '0') {
        loadTableData()
    }
})

const loadDatasRefreshLimit = throttleBtn(loadTableData)


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: _unref(t)('Operation.configPaymentChannel'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "60%",
    "z-index": 1999,
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Plus),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (bindPC()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Operation.bindpc')), 1)
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            icon: _unref(Refresh),
            onClick: _unref(loadDatasRefreshLimit)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
            ]),
            _: 1
          }, 8, ["icon", "onClick"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          ref_key: "TableCom",
          ref: TableCom,
          "row-key": "id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "paymentMode",
              label: _ctx.$t('Operation.paymentModeTypes')
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getPaymentModeDesc)(row.paymentMode)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "paymentChannel",
              label: _ctx.$t('Operation.paymentChannel')
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getPaymentChannelDesc)(row.paymentChannel)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "config.name",
              label: _ctx.$t('Base.name')
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, {
                  content: row.config.id,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.config.name), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "isDefault",
              label: _ctx.$t('Operation.defpc')
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_switch, {
                  modelValue: row.isDefault,
                  "onUpdate:modelValue": ($event: any) => ((row.isDefault) = $event),
                  "active-value": true,
                  "inactive-value": false,
                  onChange: ($event: any) => (handleSwitchDefault(row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "psDefault",
              label: _ctx.$t('Operation.pspc')
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_switch, {
                  modelValue: row.psDefault,
                  "onUpdate:modelValue": ($event: any) => ((row.psDefault) = $event),
                  "active-value": true,
                  "inactive-value": false,
                  onChange: ($event: any) => (handleSwitchPsDefault(row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              "min-width": "100",
              label: _ctx.$t('Base.createdAt')
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [
            _directive_loading,
            lockTable.value,
            void 0,
            { lock: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CommonPagination, {
            metaData: _unref(pageMeta),
            "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
            onLoadPage: loadTableData
          }, null, 8, ["metaData"])
        ])
      ]),
      _createVNode(OperatorTerminalConfigPCUpsert, {
        modelValue: showBindPCDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showBindPCDialog).value = $event)),
        operatorId: props.opeartorId
      }, null, 8, ["modelValue", "operatorId"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})